import { useBasicInfoLinks } from "./useBasicInfoLinks";
import { useExceptionLinks } from "./useExceptionLinks";
import { useMainMenuLinks } from "./useMainMenuLinks";

export const useAppLinks = () => {
  const mainMenuLinks = useMainMenuLinks();
  const basicInfoLinks = useBasicInfoLinks();
  const exceptionLinks = useExceptionLinks();

  return { mainMenuLinks, basicInfoLinks, exceptionLinks };
};
